import { type FC } from 'react';
import { DraftReplyBar } from './draft-reply-bar';
import { useDraftReply } from './use-draft-reply';

/**
 * Container for the draft preview bar. Wires {@link useDraftReply} to
 * {@link DraftReplyBar} and renders nothing when there is no draft to show.
 */
export const DraftReply: FC = () => {
  const { draftText, resumeDraft, discardDraft } = useDraftReply();

  if (draftText === null) return null;

  return <DraftReplyBar text={draftText} onResume={resumeDraft} onDiscard={discardDraft} />;
};
